import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/resume-folder-rafiki.svg'

interface Props {
  animate?: boolean
}

function CookiesIcon({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const containerClassName = containerRef.current.className
        .split(' ')
        .join('.')

      const animInstances: anime.AnimeInstance[] = []
      const animateConfig = {
        easing: 'easeInOutSine',
        direction: 'alternate',
        loop: true,
        duration: 1000,
        delay: 350,
        endDelay: 350,
      }

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #eye-brown-l`,
          translateY: ['-0.5%', '0%'],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #eye-brown-r`,
          translateY: ['-0.5%', '0%'],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #mouth`,
          transform: [
            'matrix(1, 0, 0, 1, 0, 0)',
            'matrix(0.937117,-0.349015,0.349015,0.937117,-13.9056,69.7992)',
          ],
        }),
      )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box ref={containerRef}>
      <Image />
    </Box>
  )
}
export default CookiesIcon
